import { render, staticRenderFns } from "./order-finish-demo.vue?vue&type=template&id=4be1905e&scoped=true&"
import script from "./order-finish-demo.vue?vue&type=script&lang=js&"
export * from "./order-finish-demo.vue?vue&type=script&lang=js&"
import style0 from "./order-finish-demo.vue?vue&type=style&index=0&id=4be1905e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be1905e",
  null
  
)

export default component.exports